import PersonalBookingPageOptionViewState from './schema/PersonalBookingPageOptionViewState';
import { createStore } from 'satcheljs';
import '../actions/initializeSettingsMutator';
import '../mutators/setIsSavingMutator';
import '../mutators/updatePublishingSettingsMutator';
import '../mutators/setIsPerformingServiceUpdateMutator';
import '../mutators/loadServicesMutator';
import '../mutators/createServiceMutator';
import '../mutators/deleteServiceMutator';

let initialStore: PersonalBookingPageOptionViewState = {
    publishingSettings: null,
    services: [],
    isSaving: false,
    isPerformingServiceUpdate: false,
};

export default createStore<PersonalBookingPageOptionViewState>(
    'personalBookingPageOptionStore',
    initialStore
);
